import React from 'react'

import {HiringData} from '../components/'

const Hiring = () => (
    <React.Fragment>
        <HiringData />
    </React.Fragment>
)

export default Hiring



// WEBPACK FOOTER //
// ./src/pages/hiring.js